export const priceAlertEndpoints = {
  GET_PRICE_SUMMARY: '/pricing/:productId/summary',
  GET_PRICE_HISTORY: '/pricing/:productId/history-chart',
  GET_PRICE_ALERTS: '/pricing/',
  GET_PRICE_ALERT: '/pricing/:priceAlertId/',
  CREATE_PRICE_ALERT: '/pricing/',
  UPDATE_PRICE_ALERT: '/pricing/:priceAlertId/',
  DELETE_PRICE_ALERT: '/pricing/:priceAlertId',
  GET_PRICE_ALERT_POOL: '/pricing/:priceAlertId/pool/',
  GET_RETAILER_PRODUCT_PRICE_SUMMARY: '/pricing/:productId/product-price-summary/',
  GET_RETAILER_PRODUCT_PRICE_HISTORY: '/pricing/:productId/product-price-history/',
  GET_QUARANTINED_RETAILERS: '/pricing/quarantine/',
  CREATE_QUARANTINE: '/pricing/quarantine/',
  GET_QUARANTINE_HISTORY: '/pricing/quarantine/',
  LIFT_QUARANTINE: '/pricing/quarantine/:quarantineId/lift/',
}
